<!--Do NOT change this file manually, it is being generated by 'fws icons' command.-->

<template>
    <component v-bind:is="component"/>
</template>

<script>
    import startcase from 'lodash.startcase';
    import ArrowDown from '../../../../assets/svg/ico-arrow-down.svg';
    import ArrowRight from '../../../../assets/svg/ico-arrow-right.svg';
    import ArrowUp from '../../../../assets/svg/ico-arrow-up.svg';
    import Audit from '../../../../assets/svg/ico-audit.svg';
    import Automation from '../../../../assets/svg/ico-automation.svg';
    import Badge from '../../../../assets/svg/ico-badge.svg';
    import Bookmark from '../../../../assets/svg/ico-bookmark.svg';
    import Calculator from '../../../../assets/svg/ico-calculator.svg';
    import Clock from '../../../../assets/svg/ico-clock.svg';
    import Dog from '../../../../assets/svg/ico-dog.svg';
    import Fb from '../../../../assets/svg/ico-fb.svg';
    import File from '../../../../assets/svg/ico-file.svg';
    import Hand from '../../../../assets/svg/ico-hand.svg';
    import Happy from '../../../../assets/svg/ico-happy.svg';
    import In from '../../../../assets/svg/ico-in.svg';
    import Insta from '../../../../assets/svg/ico-insta.svg';
    import Light from '../../../../assets/svg/ico-light.svg';
    import Lock from '../../../../assets/svg/ico-lock.svg';
    import Partners from '../../../../assets/svg/ico-partners.svg';
    import PhoneMail from '../../../../assets/svg/ico-phone-mail.svg';
    import Phone from '../../../../assets/svg/ico-phone.svg';
    import PlusCircle from '../../../../assets/svg/ico-plus-circle.svg';
    import Price from '../../../../assets/svg/ico-price.svg';
    import Reps from '../../../../assets/svg/ico-reps.svg';
    import Star from '../../../../assets/svg/ico-star.svg';
    import Twitter from '../../../../assets/svg/ico-twitter.svg';
    import User from '../../../../assets/svg/ico-user.svg';

    export default {
        props: {
            iconName: {
                type: String,
                required: true
            }
        },
        components: {
            ArrowDown,
            ArrowRight,
            ArrowUp,
            Audit,
            Automation,
            Badge,
            Bookmark,
            Calculator,
            Clock,
            Dog,
            Fb,
            File,
            Hand,
            Happy,
            In,
            Insta,
            Light,
            Lock,
            Partners,
            PhoneMail,
            Phone,
            PlusCircle,
            Price,
            Reps,
            Star,
            Twitter,
            User,

        },
        computed: {
            component() {
                return startcase(this.iconName.replace('ico-', '')).replace(' ', '');
            }
        }
    };
</script>
